"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinLabel = void 0;
var BoardContainer_1 = require("./BoardContainer");
var GameVars_1 = require("../../../GameVars");
var CoinLabel = /** @class */ (function (_super) {
    __extends(CoinLabel, _super);
    function CoinLabel(scene) {
        var _this = _super.call(this, scene) || this;
        _this.coinsLabel = new Phaser.GameObjects.Text(_this.scene, 0, 0, "", { fontFamily: "Baloo", fontSize: "45px", color: "#FFD445" });
        _this.coinsLabel.setOrigin(.5);
        _this.coinsLabel.setStroke("#703E25", 6);
        _this.add(_this.coinsLabel);
        _this.coinIcon = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "coin");
        _this.add(_this.coinIcon);
        return _this;
    }
    CoinLabel.prototype.reset = function (n) {
        this.alpha = 1;
        this.coinsLabel.text = GameVars_1.GameVars.formatNumber(n);
        this.coinIcon.x = -this.coinsLabel.width / 2 - 20;
    };
    CoinLabel.prototype.animate = function () {
        this.scene.tweens.add({
            targets: this,
            y: this.y - 40,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: 300
        });
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 400,
            delay: 600,
            onComplete: function () {
                BoardContainer_1.BoardContainer.putBackCoinLabel(this);
            },
            onCompleteScope: this
        });
    };
    return CoinLabel;
}(Phaser.GameObjects.Container));
exports.CoinLabel = CoinLabel;
